import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/data';

export default function FeaturedArticles() {
  const featuredArticles = articles.slice(0, 6);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm">
              由专业编辑团队精选的优质内容
            </p>
          </div>
          <Link
            to="/category/zixun"
            className="flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              slug={article.slug}
              summary={article.summary}
              category={article.category}
              categoryName={getCategoryName(article.category)}
              coverImage={article.coverImage}
              author={article.author}
              publishedAt={article.publishedAt}
              readTime={article.readTime}
            />
          ))}
        </div>
      </div>
    </section>
  );
}